import { z } from "zod";

export const LambdaErrorBodySchema = z.object({
  error: z.string(),
});
export type LambdaErrorBody = z.infer<typeof LambdaErrorBodySchema>;

export const ApiErrorSchema = z.object({
  message: z.string(),
  code: z.string(),
  statusCode: z.number().int(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;
